import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';

const ScrollableTextBox = ({ id, lines = [] }) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [lines]); // scroll to bottom when lines update

  return (
    <Box
      id={id}
      ref={scrollRef}
      sx={{
        height: 100,
        width: '100%',
        overflowY: 'auto',
        scrollSnapType: 'y mandatory',
        p: 2,
        color: 'text.secondary',
        border: '2px solid',
        borderColor: 'divider.main',
        borderRadius: 4,
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
      }}
    >
      {lines.map((line, index) => (
        <Typography 
          key={index} 
          align="center" 
          sx={{
            p: 1,
            border: '4px solid transparent',
            scrollSnapAlign: 'end',
          }} 
          variant='h5'
        >
          {line.toUpperCase()}
        </Typography>
      ))}
    </Box>
  );
};

export default ScrollableTextBox;
